'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './feedback.routes';

export class FeedbackComponent {
    /*@ngInject*/
    constructor($anchorScroll, searchService, $state, $window, $location, $stateParams, $http) {
        this.message = 'Hello';
        this.$http = $http;
        this.$location = $location;
        this.searchService = searchService;
        this.$state = $state;
        this.$window = $window;
        this.$stateParams = $stateParams;
        this.feedback = {};
        this.failed = false;
        this.success = false;
        this.savingSpinner = false;
    }

    $onInit() {
        var key;
        this.$anchorScroll;
        this.$scope.baseURL = this.searchService.getBaseURL();
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        this.article = this.searchService.getArticle();
        console.log(this.article);

        if (!this.$location.search().id && this.article) {
            this.$location.search('id', this.article.uuid);

        }

        //Check if key exists in service
        if (this.searchService.getKey()) {
            key = this.searchService.getKey();
            this.hasKey = true;
            this.key = key;
        } else if (this.$location.search().key) {
            key = this.$location.search().key;
            this.key = key;
            this.hasKey = true;
        } else {
            this.hasKey = false;
        }

        //If no key exists in url, add parameter
        if (!this.$location.search().key) {
            console.log(key);

            this.$location.search('key', key);
        }

        if (!this.searchService.getKey()) {
            this.searchService.setKey(this.key);
        }
    }

    submitFeedback() {
        this.savingSpinner = true;
        console.log(this.feedback);
        this.$http.post(`${this.$scope.baseURL}/api/users/feedback`, this.feedback)
            .then(response => {
                this.savingSpinner = false;
                console.log(response);
                this.feedback = {};
                this.success = true;
                this.failed = false;
                console.log(this.savingSpinner);

            })
            .catch(err => {
                this.savingSpinner = false;
                console.log(err);
                this.success = false;
                this.failed = true;


            })

    }
}

export default angular.module('webApp.feedback', [uiRouter])
    .config(routes)
    .component('feedback', {
        template: require('./feedback.html'),
        controller: FeedbackComponent,
        controllerAs: 'feedbackCtrl'
    })
    .name;


// WEBPACK FOOTER //
// ./client/app/feedback/feedback.component.js